import { netsparkAxios } from 'core/services/HTTPService';
import getUserManagementListUrl from './apiUrls';

const getUserManagementList = (params) => netsparkAxios.get(getUserManagementListUrl, { params });

export default getUserManagementList;
